const LOCAL_TIMESTAMP_FORMATTER = new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
});

const ISO_WITHOUT_TZ_PATTERN = /^\d{4}-\d{2}-\d{2}[T ][0-9:.]+$/;

function parseTimestamp(value: string): Date {
    const candidate = value.trim();
    if (ISO_WITHOUT_TZ_PATTERN.test(candidate)) {
        return new Date(candidate.replace(' ', 'T') + 'Z');
    }
    return new Date(candidate);
}

export function formatLocalTimestamp(value?: string | null): string {
    if (!value) return '-';
    const parsed = parseTimestamp(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return LOCAL_TIMESTAMP_FORMATTER.format(parsed);
}
